module.exports = __webpack_public_path__ + "static/media/RiceBowlChkn.9ce413ae.jpg";